import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appInitials'
})
export class InitialsPipe implements PipeTransform {
  public transform(firstName: string, lastName: string, fallback: string = 'N/A'): string {
    let firstLetter = firstName?.charAt(0) ?? '';
    let lastLetter = lastName?.charAt(0) ?? '';
    const initials = firstLetter + lastLetter;
    return initials.toUpperCase() || fallback;
  }
}
